module.exports = __webpack_public_path__ + "img/8.d68b6ae5.jpg";